import { combineReducers } from "redux";

// V3 Reducer
import {devices} from './devices'
import {devicesMDVR} from './devicesMDVR'
import {deviceGroups} from './deviceGroups'
import { driverPretripChecklists } from "./driverPretripChecklist";
import { drivers } from "./drivers";
import {geofences} from './geofences'
import {geofenceTemplates} from './geofenceTemplates'
import {maintenanceConfigs} from './maintenanceConfigs'
import { notifications } from "./notifications";
import { liveCamera } from "./liveCamera";
import { locationTracking } from "./locationTracking";
import {mapControl} from './mapControl'
// export {reportDailySummaries} from './reportDailySummaries'
import {rules} from './rules'
import {ruleTemplates} from './ruleTemplates'
import {statusBar} from './statusBar'
import {style} from './style'
import {subscriptionPackages} from './subscriptionPackages'
import { surveillances } from './surveillances'
import {transitRecords} from './transitRecords'
import {tripRecords} from './tripRecords'
import {user} from './user';
import {userHierarchy} from './userHierarchy'
import {userRoles} from './userRoles'
import {utils} from './utils'
import {vehicles} from './vehicles'
import {vehicleLogs} from './vehicleLogs'
import {vehicleDerivativeLogs} from './vehicleDerivativeLogs'
import {vehicleECULogs} from './vehicleECULogs'
import {vehicleEventLogs} from './vehicleEventLogs'
import {vehicleGeoStateLogs} from './vehicleGeoStateLogs'
import {vehicleGroups} from './vehicleGroups'
import {vehicleMaintenances} from './vehicleMaintenances'
import {vehicleReportDailySummaries} from './vehicleReportDailySummaries'
import {vehicleReportFuelAnalysis} from './vehicleReportFuelAnalysis'
import { vehicleReportRefuel } from "./vehicleReportRefuel";
import { vehicleReportGeofences } from "./vehicleReportGeofence";
import { reports } from './reports'
import { vehicleReport } from './vehicleReport'

// VAM Modules
import {vamEntries} from './vamEntries'
import {vamLines} from './vamLines'
import {vamPrograms} from './vamPrograms'
import {vamReminders} from './vamReminders'
import { vamVehicleIssue } from "./vamVehicleIssue";

export const v3Reducer = combineReducers({
    devices,
    devicesMDVR,
    deviceGroups,
    driverPretripChecklists,
    drivers,
    geofences,
    geofenceTemplates,
    liveCamera,
    locationTracking,
    maintenanceConfigs,
    mapControl,
    notifications,
    // reportDailySummaries,
    rules,
    ruleTemplates,
    statusBar,
    user,
    userRoles,
    userHierarchy,
    utils,
    style,
    subscriptionPackages,
    surveillances,
    transitRecords,
    tripRecords,
    vehicles,
    vehicleLogs,
    vehicleDerivativeLogs,
    vehicleECULogs,
    vehicleEventLogs,
    vehicleGeoStateLogs,
    vehicleGroups,
    vehicleMaintenances,
    vehicleReportDailySummaries,
    vehicleReportFuelAnalysis,
    vehicleReportRefuel,
    vehicleReportGeofences,
    vehicleReport,
    reports,
    // VAM Modules
    vamEntries,
    vamLines,
    vamPrograms,
    vamReminders,
    vamVehicleIssue,
})